import styled from 'styled-components';

export const FormContainer = styled.div`
  dl {
    margin-bottom: 24px;
  }
`;
